const FontFamily = {
  sans: '"Seed Sans", system-ui, "Helvetic Neue", "Helvetica", Arial, sans-serif',
  sansMedium:
    '"Seed Sans", system-ui, "Helvetic Neue", "Helvetica", Arial, sans-serif',
  mono: '"Seed Sans Mono", monospace',
};

export { FontFamily };
